/*
 * @Author: Administrator
 * @Date:   2019-08-07 15:35:59
 * @Last Modified by:   Administrator
 * @Last Modified time: 2019-12-19 15:39:07
 */
let baseUrl = '',
  baseImgUrl = '',
  aMapApk = '',
  baseExportUrl = '',
  switchUnite = true;


if (process.env.NODE_ENV === 'development') {
  // baseUrl = baseImgUrl = baseExportUrl = 'http://192.168.1.19:9200';
  // baseUrl = baseImgUrl = 'http://192.168.3.65:9200'; // 汪于杰
  // baseUrl = baseImgUrl = 'http://192.168.3.34:9200';// 吴松林
  // baseUrl = baseImgUrl = 'http://192.168.3.120:9200';// 胡耀博
  // baseUrl = baseImgUrl = 'http://192.168.3.83:9200'; // 刘佳-公司
  // baseUrl = baseImgUrl = 'http://192.168.0.141:9200'; // 刘佳-民生
  // baseUrl = baseImgUrl = 'http://121.36.21.220:9200'; // 测试
  // baseUrl = baseImgUrl = baseExportUrl = 'https://mslogistics.cn';
  // baseUrl = baseImgUrl = baseExportUrl = 'https://mslogistics.cn';
  baseUrl = baseImgUrl = baseExportUrl = 'http://127.0.0.1:9200';
  // baseUrl = baseImgUrl = baseExportUrl = 'http://192.168.0.197:9200';
  // baseUrl = baseImgUrl = baseExportUrl = 'http://localhost:9200';
  // baseUrl = baseImgUrl = 'http://jwxc6d.natappfree.cc';
  // baseUrl = baseImgUrl = 'http://192.168.0.137:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.125:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.145:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.196:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.157:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.124:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.138:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.144:9200';
  // baseUrl = baseImgUrl = 'http://192.168.1.87:9200';
  // baseUrl = baseImgUrl = 'http://192.168.1.98:9200';
  // baseUrl = baseImgUrl = 'http://192.168.0.144:9200'; // 刘林
  //baseUrl = baseImgUrl = 'http://192.168.1.62:9200';// 吴松林
  // baseUrl = 'http://192.168.226.245:9200';
  // baseUrl='http://114.116.242.185:9200';
  // baseUrl = 'https://mslogistics.cn/';
  //  baseUrl='http://172.20.28.50:9200';
  // baseUrl = 'http://localhost:9200';
  aMapApk = 'ed0557f87bad6be36d2c4e460e5c3184';
  // baseImgUrl = 'http://192.168.0.177:9200';
  // baseImgUrl = 'http://192.168.3.149:9200'; // 吴松林
  // baseImgUrl = 'http://192.168.226.245:9200';
  // baseImgUrl='http://172.20.28.50:9200';
  // baseImgUrl = 'http://113.204.53.10:8888'
  // baseImgUrl = 'http://114.116.242.185:9200';
  // baseImgUrl='https://mslogistics.cn/';
  // baseImgUrl = 'http://localhost:8888'
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = baseExportUrl = window.globalConfig.baseUrl;
  aMapApk = 'ed0557f87bad6be36d2c4e460e5c3184';
  baseImgUrl = window.globalConfig.baseImgUrl;

  // 当前ip
  const urlType = window.location.host;

  window.console.log(urlType);

  if (urlType) {
    // 截取ip
    const ip = urlType.split(':')[0];

    if ('http://172.20.28.50:81'.indexOf(ip) !== -1) {
      baseImgUrl = baseUrl = 'http://172.20.28.50:81';
    }
  }

}

export {
  baseUrl, aMapApk, baseImgUrl, baseExportUrl, switchUnite
};
